import React from 'react';
import { Box, BoxProps, Flex } from '@withjoy/joykit';
import { EditorSortableItemLayout } from '@apps/admin/components/EditorSortableItemLayout';
import { TextEllipsisWrapper } from '@shared/utils/formatting/textEllipsis';
import { pxToRem } from '@withjoy/joykit/theme';

interface LayoutEditComponentListItemProps {
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  thumbnailUrls?: string[];
  isDragActive: boolean;
  dragItemId: string;
  isLastItem?: boolean;
  height?: number;
  itemId: string;
  photoUrl?: string;
  icon?: React.ReactNode;
  isHover: boolean;
  setIsHover: (isHover: boolean) => void;
  handleEdit: () => void;
  handleDelete?: () => void;
  hideDelete?: boolean;
  cardPaddingY?: BoxProps['paddingY'];
}

export const THUMBNAIL_DIMENSIONS = {
  width: 99,
  height: 72,
};

const Thumbnail = (props: { thumbnailUrl: string }) => {
  const { thumbnailUrl } = props;
  return (
    <Box
      width="fit-content"
      borderRadius={pxToRem(6)}
      border={'2px solid transparent'}
      _groupHover={{ borderColor: 'linkHover' }}
      cursor="pointer"
    >
      <Box
        backgroundImage={`url("${thumbnailUrl}")`}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        width={pxToRem(THUMBNAIL_DIMENSIONS.width)}
        height={pxToRem(THUMBNAIL_DIMENSIONS.height)}
        borderRadius={pxToRem(4)}
        overflow={'hidden'}
        margin={pxToRem(2)}
      />
    </Box>
  );
};

export const LayoutEditComponentListItem: React.FC<LayoutEditComponentListItemProps> = props => {
  const { title, subTitle, thumbnailUrls, handleEdit, handleDelete, hideDelete, ...restProps } = props;
  return (
    <EditorSortableItemLayout
      {...restProps}
      borderSpacing={48}
      handleClick={handleEdit}
      handleDelete={
        handleDelete
          ? (e: React.MouseEvent<Element, MouseEvent>) => {
              e.stopPropagation();
              handleDelete();
            }
          : undefined
      }
      hideDelete={hideDelete}
    >
      <Flex
        flexDirection="column"
        rowGap={1}
        width={hideDelete ? '85%' : '75%'}
      >
        {title && <TextEllipsisWrapper>{title}</TextEllipsisWrapper>}
        {thumbnailUrls ? (
          <Flex
            flexDirection="row"
            gap={1}
            overflow="hidden"
          >
            {thumbnailUrls.map(url => (
              <Thumbnail
                key={url}
                thumbnailUrl={url}
              />
            ))}
          </Flex>
        ) : null}
        {subTitle && <TextEllipsisWrapper lineClamp={2}>{subTitle}</TextEllipsisWrapper>}
      </Flex>
      <Box
        background="linear-gradient(90deg, #FFF 0%, rgba(255, 255, 255, 0.00) 0.01%, #FFF 100%)"
        _groupHover={{ background: 'linear-gradient(90deg, #FFF 0%, rgba(255, 255, 255, 0.00) 0.01%, #F7F7F7 100%)' }}
        _groupActive={{ background: 'linear-gradient(90deg, #FFF 0%, rgba(255, 255, 255, 0.00) 0.01%, #EBEBEB 100%)' }}
        width={9}
        height="100%"
        position="absolute"
        right={6}
      />
      {props.children}
    </EditorSortableItemLayout>
  );
};
